var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.14 253.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2531c64-1294-4bcb-92b3-506a34db3894,.a5677b3f-75ad-42f0-aca8-721049f7f93f,.fdc9240b-77cb-4b6a-94f9-f69835bd4e6e{fill:#fff;}.fdc9240b-77cb-4b6a-94f9-f69835bd4e6e{opacity:0.1;}.a2531c64-1294-4bcb-92b3-506a34db3894{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ea0b6c59-5f4e-4fc0-864a-abb71ae645aa",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f0c38142-531b-42ea-9248-1a193d5deafb",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fdc9240b-77cb-4b6a-94f9-f69835bd4e6e",
    cx: 126.57,
    cy: 126.57,
    r: 126.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2531c64-1294-4bcb-92b3-506a34db3894",
    d: "M64,179.36,85.21,43.83a3.83,3.83,0,0,1,4.5-3.23,4.07,4.07,0,0,1,2.83,2l21.91,40.88,8.7-16.63a3.88,3.88,0,0,1,5.28-1.66,4.56,4.56,0,0,1,1.66,1.66l59.06,112.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2531c64-1294-4bcb-92b3-506a34db3894",
    d: "M137.23,126.55,114.45,83.43,64,179.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5677b3f-75ad-42f0-aca8-721049f7f93f",
    d: "M189.15,179.36,172.92,78.93a3.94,3.94,0,0,0-4.5-3.22,3.71,3.71,0,0,0-2.15,1.07L64,179.36l56.62,31.78a11.86,11.86,0,0,0,11.44,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.08acf18e.svg";
export { ForwardRef as ReactComponent };